import { useCallback, useState } from 'react'
import type { GlobalMessage } from '../types'

const storageKey = (message: GlobalMessage): string =>
  `global_message_dismiss_${message.id}`

const readDismissedUpdate = (message: GlobalMessage): string | null => {
  try {
    return localStorage.getItem(storageKey(message))
  } catch {
    return null
  }
}

export const useDismissedGlobalMessages = () => {
  const [dismissedKeys, setDismissedKeys] = useState<string[]>([])

  const isDismissed = useCallback(
    (message: GlobalMessage): boolean =>
      dismissedKeys.includes(`${message.id}-${message.updatedAt}`) ||
      readDismissedUpdate(message) === message.updatedAt,
    [dismissedKeys]
  )

  const dismiss = useCallback((message: GlobalMessage): void => {
    setDismissedKeys((keys) => [...keys, `${message.id}-${message.updatedAt}`])
    try {
      localStorage.setItem(storageKey(message), message.updatedAt)
    } catch {}
  }, [])

  return { isDismissed, dismiss }
}
